<template>

  <div class="user">
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" class="demo-form-inline">
      
        <el-form-item >
          <el-button type="primary" icon="el-icon" @click="buy">购买广告</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.code" placeholder="广告类型">
            <el-option label="全部" value=""></el-option>
            <el-option label="广告" value="ad"></el-option>
            <el-option label="关键字" value="keyword"></el-option>
            <el-option label="商品排名" value="store"></el-option>
            <el-option label="诚优企业" value="coc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.name" placeholder="请输入广告名称"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-select v-model="formInline.expire_time" placeholder="到期时间">
            <el-option label="全部" value=""></el-option>
            <el-option label="小于3天" value="three"></el-option>
            <el-option label="小于7天" value="seven"></el-option>
            <el-option label="小于15天" value="fifteen"></el-option>
            <el-option label="小于30天" value="thirty"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name"  label="姓名"> </el-table-column>
            <el-table-column prop="phone"  label="联系方式"> </el-table-column>
            <el-table-column prop="name" label="广告名称">
              <template slot-scope="scope">
                  {{ scope.row.ad.name }}({{  scope.row.ad.ad_id }})
              </template>	
            </el-table-column>
            <el-table-column prop="supply.name"  label="企业"> </el-table-column>
            <el-table-column prop="index"  label="图片位置"> </el-table-column>
            <el-table-column prop="ad.code"  label="类型"> 
              <template slot-scope="scope">
                <span v-if="scope.row.ad.code == 'ad'">广告</span>
                <span v-if="scope.row.ad.code == 'keyword'">关键字</span>
                <span v-if="scope.row.ad.code == 'store'">企业排名</span>
              </template>

            </el-table-column>
            <el-table-column prop="ad.keyword"  label="关键字"> </el-table-column>
            <el-table-column prop="location"  label="广告位置"> </el-table-column>
            <!-- <el-table-column prop="page_url"  label="跳转页面"> </el-table-column> -->
            <el-table-column prop="status_val" label="状态"> </el-table-column> 
            
            <el-table-column prop="type" label="多图/单图">
                <template slot-scope="scope">
                  <div v-if="scope.row.ad.type == 1">
                    bannar（多图）
                  </div>
                  <div v-if="scope.row.ad.type == 2">
                    单图
                  </div>
               </template>	
            </el-table-column>   
            <el-table-column prop="price"  label="所花费用"> 
              <template slot-scope="scope">
                  <div>{{ scope.row.price * scope.row.num }}</div>
               </template>	

            </el-table-column>
            <el-table-column prop="num"  label="天数"> </el-table-column>
            
            <el-table-column prop="ex" label="是否到期"> </el-table-column> 
            <el-table-column prop="start_time"  label="开始时间"> </el-table-column>
            <el-table-column prop="end_time"  label="到期时间"> </el-table-column>
            <el-table-column label="图片" >
                <template slot-scope="scope">
                  <img
                  v-if="scope.row.image"
                    v-img-url="scope.row.image.file_path?scope.row.image.file_path:scope.row.image_url"
                    width="100"
                    height="60"
                  />
                </template>
            </el-table-column>
         

 
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AdApi from '@/api/ad.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      formInline: {
        expire_time:"three",
        code:"",
        name:""
      },
      status: ['未开始', '进行中', '已结束']
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    buy(){
       this.$router.push({
        path: '/plus/ad/ad/isBuyRecordList',
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      AdApi.recordList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加活动*/
    addClick() {
      this.$router.push('/plus/ad/ad/add');
    },

    /*编辑活动*/
    editClick(row) {
      let ad_record_id = row.ad_record_id;
      this.$router.push({
        path: '/plus/ad/ad/buyedit',
        query: {
          ad_record_id: ad_record_id,
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          AdApi.delAd(
            {
              ad_id: row.ad_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style>
.w150{
    border: 1px solid #eee;
  }
  .tc{
    border: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/ad/ad/recordList.vue